import Menu from '../../components/globalComponents/headerMenu/menu';
import Footer from '../../components/globalComponents/footer/footer';

// Página provisional para las secciones nuevas que aún no están hechas.
const EnConstruccion = ({ titulo }) => {
  return (
    <>
      <Menu />
      <main
        style={{
          minHeight: '60vh',
          paddingTop: '160px',
          paddingBottom: '80px',
          textAlign: 'center',
        }}
      >
        <h1 className="header-title__sub-page">{titulo}</h1>
        <p className="header-text__main-page">Página en construcción.</p>
      </main>
      <Footer />
    </>
  );
};

export default EnConstruccion;